import { render, staticRenderFns } from "./StudentPersonalLearningMapProgress.vue?vue&type=template&id=2a4473c6&scoped=true&lang=pug&"
import script from "./StudentPersonalLearningMapProgress.vue?vue&type=script&lang=ts&"
export * from "./StudentPersonalLearningMapProgress.vue?vue&type=script&lang=ts&"
import style0 from "./StudentPersonalLearningMapProgress.vue?vue&type=style&index=0&id=2a4473c6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4473c6",
  null
  
)

export default component.exports